export enum CommentType {
   User = 1,
   System = 2,
   Ai = 3
}
